"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var __1 = require("..");
var useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        zIndex: 10,
        position: 'absolute',
        top: '50%',
        marginTop: '-20px',
        width: '40px',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
});
function CarouselControl(_a) {
    var _b;
    var type = _a.type, offset = _a.offset, onClick = _a.onClick;
    var styles = useStyles();
    return (react_1.default.createElement("div", { className: styles.root, style: (_b = {},
            _b[type] = offset,
            _b), onClick: onClick },
        react_1.default.createElement(__1.Icon, { name: type === 'left' ? 'arrowBack' : 'arrowForward' })));
}
exports.default = CarouselControl;
//# sourceMappingURL=CarouselControl.js.map